import { render } from "./CarritoView.vue?vue&type=template&id=f5c35ece"
import script from "./CarritoView.vue?vue&type=script&lang=js"
export * from "./CarritoView.vue?vue&type=script&lang=js"

import "./CarritoView.vue?vue&type=style&index=0&id=f5c35ece&lang=css"

import exportComponent from "D:\\laragon\\www\\balkum-pwa\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__